let prevGifts = 'no_gift';

// function checkAndAddGifts() {
//   if (enable_mystery_gifts && mystery_gift_id_1 && mystery_gift_id_2) {
//     const bfcmElement = document.querySelector('.gift_free_1');
//     const bfcmGift = bfcmElement.getAttribute('data-bfcm-gift');

//     const updateCart = async (updates) => {
//       await fetch('/cart/update.js', { 
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({ updates })
//       })
//       .then(response => response.json())
//       .catch(error => {
//         console.error('Error updating cart:', error);
//       });
//     };
  
//     switch (bfcmGift) {
//       case "gift1":
//         updateCart({ [mystery_gift_id_1]: 1, [mystery_gift_id_2]: 0 });
//         console.log('--------1---------');
//         break;
//       case "gift2":
//         updateCart({ [mystery_gift_id_1]: 1, [mystery_gift_id_2]: 1 });
//         console.log('--------2---------');
//         break;
//       default:
//         updateCart({ [mystery_gift_id_1]: 0, [mystery_gift_id_2]: 0 });
//         console.log('--------0---------');
//         break;
//     }

//     console.log('-----------------', prevGifts, bfcmGift);

//     if (prevGifts != bfcmGift) {
//       prevGifts = bfcmGift;
//       updateCartDrawer();           
//     }
//   }
// }

async function checkAndAddGifts() {
  if (enable_mystery_gifts && mystery_gift_id_1 && mystery_gift_id_2) {
    const bfcmElement = document.querySelector('.gift_free_1');
    const bfcmGift = bfcmElement.getAttribute('data-bfcm-gift');

    const updateCart = async (updates) => {
      try {
        const response = await fetch('/cart/update.js', { 
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        });
        return response.json();
      } catch (error) {
        console.error('Error updating cart:', error);
      }
    };

    let cartUpdatePromise;

    switch (bfcmGift) {
      case "gift1":
        cartUpdatePromise = updateCart({ [mystery_gift_id_1]: 1, [mystery_gift_id_2]: 0 });
        break;
      case "gift2":
        cartUpdatePromise = updateCart({ [mystery_gift_id_1]: 1, [mystery_gift_id_2]: 1 });
        break;
      default:
        cartUpdatePromise = updateCart({ [mystery_gift_id_1]: 0, [mystery_gift_id_2]: 0 });
        break;
    }

    if (prevGifts !== bfcmGift) {
      prevGifts = bfcmGift;
      await cartUpdatePromise;
      await updateCartDrawer();
    }
  }
}


function addCartDrawerListeners() {
  /*if (enable_mystery_gifts && mystery_gift_id_1 && mystery_gift_id_2) {
    const bfcmElement = document.querySelector('.gift_free_1');
    const bfcmGift = bfcmElement.getAttribute('data-bfcm-gift');

    const updateCart = (updates) => {
      fetch('/cart/update.js', { 
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ updates })
      })
      .then(response => response.json())
      .catch(error => {
        console.error('Error updating cart:', error);
      });
    };
  
    switch (bfcmGift) {
      case "gift1":
        updateCart({ [mystery_gift_id_1]: 1, [mystery_gift_id_2]: 0 });
        break;
      case "gift2":
        updateCart({ [mystery_gift_id_1]: 1, [mystery_gift_id_2]: 1 });
        break;
      default:
        updateCart({ [mystery_gift_id_1]: 0, [mystery_gift_id_2]: 0 });
        break;
    }
  }*/

  document.querySelectorAll(".quantity-btn").forEach((button) => {
    button.addEventListener("click", async (event) => {
      event.preventDefault();
      event.stopPropagation();

      const parent = button.parentElement.parentElement;
      const key =
        parent.parentElement.parentElement.parentElement.getAttribute(
          "data-line-item-key"
        );
      const giftsToUpdate = button.getAttribute("data-gifts");
      const quantityInput = parent.querySelector("input");
      const buttonsContainer = parent.querySelector(
        ".quantity-buttons-container"
      );
      const loader = parent.querySelector(".quantity-loader");
      // Disable both the + and - buttons
      const minusButton = parent.querySelector(".quantity-minus");
      const plusButton = parent.querySelector(".quantity-plus");
      minusButton.style.pointerEvents = "none";
      plusButton.style.pointerEvents = "none";

      buttonsContainer.classList.add("hidden");
      loader.style.display = "block";

      const currentQuantity = quantityInput.value;
      const isUp = button.classList.contains("quantity-plus");
      const newQuantity = isUp ? +currentQuantity + 1 : +currentQuantity - 1;

      if (!giftsToUpdate) {
        let updates = {
          [key]: newQuantity,
        };

        try {
          const response = await fetch(
            window.Shopify.routes.root + "cart/update.js",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ updates }),
            }
          );
        } finally {          
          await updateCartDrawer();

          quantityInput.value = newQuantity;
          buttonsContainer.classList.remove("hidden");
          loader.style.display = "none";

          // Re-enable the buttons
          minusButton.style.pointerEvents = "all";
          plusButton.style.pointerEvents = "all";
        }
      } else {
        const gifts = giftsToUpdate.split(",");
        const giftUpdates = {};
        let productUpdate = {
          [key]: newQuantity,
        };
        for (const gift of gifts) {
          localStorage.setItem(`gift_${gift}_quantity`, newQuantity);
          if (newQuantity <= 0) {
            giftUpdates[gift] = 0;
          } else {
            giftUpdates[gift] = newQuantity;
          }
        }
        let updates = { ...productUpdate, ...giftUpdates };
        try {
          const response = await fetch(
            window.Shopify.routes.root + "cart/update.js",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ updates }),
            }
          );
        } finally {
          await updateCartDrawer();

          quantityInput.value = newQuantity;
          buttonsContainer.classList.remove("hidden");
          loader.style.display = "none";

          // Re-enable the buttons
          minusButton.style.pointerEvents = "all";
          plusButton.style.pointerEvents = "all";
        }
      }
    });
  });

  document.querySelectorAll(".close_cart_btn").forEach((btn) => {
    btn.addEventListener("click", (event) => {
      event.preventDefault();
      $("html").css("overflow", "unset");
      document.getElementById("byteex_cart_drawer").style.display = "none";
    });
  });

  //   const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  //   // Conditional display of buttons
  //   if (isIOS) {
  //     const applePayButton = document.querySelector('.apple_pay_button');
  //     if (applePayButton) {
  //       applePayButton.classList.remove('hidden');
  //       applePayButton.classList.add('flex');
  //     }

  //   } else {
  //     const googlePayButton = document.querySelector('.google_pay_button');
  //     if (googlePayButton) {
  //       googlePayButton.classList.remove('hidden');
  //       googlePayButton.classList.add('flex');
  //     }
  //   }
  //   const skeletonButton = document.querySelector('.skeleton_button');

  //   if (skeletonButton) {
  //     skeletonButton.classList.remove('flex');
  //     skeletonButton.classList.add('hidden');
  //   }

  //   const paymentTypes = ['GooglePay', 'ApplePay', 'ShopifyPay'];

  //   // Handle activation for each payment type
  //   paymentTypes.forEach(paymentType => {
  //     if (localStorage.getItem(paymentType) === 'true') {
  //       handlePaymentActivation(paymentType);
  //     }
  //   });

  //   function handlePaymentActivation(paymentType) {
  //     const container = document.querySelector('.loader_container');
  //     if (container) {
  //       container.style.display = 'flex';
  //       container.querySelector('.loader').style.display = 'block';
  //     }

  //     if (localStorage.getItem('ApplePay') === 'true') {
  //       const overlay = document.querySelector('.loader_container');
  //       const container = document.querySelector('#apple_pay_confirm_container');

  //       document.querySelector('body').style.overflow = 'hidden';
  //       container.classList.remove('translate-y-full');
  //       container.classList.add('translate-y-none');
  //       overlay.style.display = 'block';
  //       container.querySelector('.loader').style.display = 'block';

  //       const intervalId = setInterval(() => {
  //         const applePayButton = document.querySelector('.shopify-cleanslate [role="button"][data-testid="ApplePay-button"]');

  //         if (applePayButton) {
  //           document.querySelector('.additional_checkout_buttons_container').style.display = 'block';
  //           applePayButton.parentElement.style.display = 'block';
  //           localStorage.removeItem('ApplePay');
  //           container.querySelector('.loader').style.display = 'none';
  //           clearInterval(intervalId);
  //         } else {
  //           console.error('ApplePay Button not found');
  //         }
  //       }, 1000);

  //       overlay.addEventListener('click', (e) => {
  //         if (!container.contains(e.target)) {
  //           overlay.style.display = 'none';
  //           container.classList.remove('translate-y-none');
  //           container.classList.add('translate-y-full');
  //           clearInterval(intervalId);
  //         }
  //       });

  //     } else {
  //       const intervalId = setInterval(() => {
  //         const buttonSelector = `[data-testid="${paymentType}-button"]`;
  //         const paymentButton = document.querySelector(buttonSelector);

  //         if (paymentButton) {
  //           paymentButton.click();
  //           localStorage.removeItem(paymentType);
  //           if (container) {
  //             container.style.display = 'none';
  //             container.querySelector('.loader').style.display = 'none';
  //           }
  //           clearInterval(intervalId);
  //         } else {
  //           console.error(`${paymentType} Button not found`);
  //         }
  //       }, 1000);
  //     }
  //   }

  // function activatePayment(paymentType, event) {
  //   event.preventDefault();
  //   localStorage.setItem(paymentType, 'true');
  //   window.location.reload();
  // }

  // /*document.querySelector('.google_pay_button').addEventListener('click', (event) => activatePayment('GooglePay', event));
  // document.querySelector('.shopify_pay_button').addEventListener('click', (event) => activatePayment('ShopifyPay', event));
  // document.querySelector('.apple_pay_button').addEventListener('click', (event) => activatePayment('ApplePay', event));*/

  // const google_pay_button = document.querySelector('.google_pay_button');
  // if (google_pay_button) {
  //   google_pay_button.addEventListener('click', (event) => activatePayment('GooglePay', event));
  // }

  // const shopify_pay_button = document.querySelector('.shopify_pay_button');
  // if (shopify_pay_button) {
  //   shopify_pay_button.addEventListener('click', (event) => activatePayment('ShopifyPay', event));
  // }

  // const apple_pay_button = document.querySelector('.apple_pay_button');
  // if (apple_pay_button) {
  //   apple_pay_button.addEventListener('click', (event) => activatePayment('ApplePay', event));
  // }
}

async function updateCartDrawer() {
  const res = await fetch("/?section=byteex_cart_drawer");
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;

  const newContent = html.querySelector(".byteex_cart_drawer").innerHTML;
  document.querySelector(".byteex_cart_drawer").innerHTML = newContent;

  const result = await fetch("/cart.js");
  const cart = await result.json();
  updateCartItemCount(cart.item_count);

  checkAndAddGifts();

  updateNailVariables();
  addCartDrawerListeners();
  addColorChangeListeners();
  //addAddditionalCheckoutButtons();

  const paymentTypes = ["GooglePay", "ApplePay", "ShopifyPay"];

  // Handle activation for each payment type
  paymentTypes.forEach((paymentType) => {
    if (localStorage.getItem(paymentType) === "true") {
      handlePaymentActivation(paymentType);
    }
  });

  function handlePaymentActivation(paymentType) {
    const container = document.querySelector(".loader_container");
    if (container) {
      container.style.display = "flex";
      container.querySelector(".loader").style.display = "block";
    }

    if (localStorage.getItem("ApplePay") === "true") {
      const overlay = document.querySelector(".loader_container");
      const container = document.querySelector("#apple_pay_confirm_container");

      document.querySelector("body").style.overflow = "hidden";
      container.classList.remove("translate-y-full");
      container.classList.add("translate-y-none");
      overlay.style.display = "block";
      container.querySelector(".loader").style.display = "block";

      setTimeout(() => {
        const applePayButton = document.querySelector(
          '.shopify-cleanslate [role="button"][data-testid="ApplePay-button"]'
        );

        if (applePayButton) {
          document.querySelector(
            ".additional_checkout_buttons_container"
          ).style.display = "block";
          applePayButton.parentElement.style.display = "block";
        } else {
          console.error("ApplePay Button not found");
        }

        localStorage.removeItem("ApplePay");
        container.querySelector(".loader").style.display = "none";
      }, 10000);

      overlay.addEventListener("click", (e) => {
        if (!container.contains(e.target)) {
          overlay.style.display = "none";
          container.classList.remove("translate-y-none");
          container.classList.add("translate-y-full");
        }
      });
    } else {
      setTimeout(() => {
        const buttonSelector = `[data-testid="${paymentType}-button"]`;
        const paymentButton = document.querySelector(buttonSelector);

        if (paymentButton) {
          paymentButton.click();
        } else {
          console.error(`${paymentType} Button not found`);
        }

        localStorage.removeItem(paymentType);
        if (container) {
          container.style.display = "none";
          container.querySelector(".loader").style.display = "none";
        }
      }, 10000);
    }
  }

  function activatePayment(paymentType, event) {
    event.preventDefault();
    localStorage.setItem(paymentType, "true");
    window.location.reload();
  }

  /*document.querySelector('.google_pay_button').addEventListener('click', (event) => activatePayment('GooglePay', event));
  document.querySelector('.shopify_pay_button').addEventListener('click', (event) => activatePayment('ShopifyPay', event));
  document.querySelector('.apple_pay_button').addEventListener('click', (event) => activatePayment('ApplePay', event));*/

  const google_pay_button = document.querySelector(".google_pay_button");
  if (google_pay_button) {
    google_pay_button.addEventListener("click", (event) =>
      activatePayment("GooglePay", event)
    );
  }

  const shopify_pay_button = document.querySelector(".shopify_pay_button");
  if (shopify_pay_button) {
    shopify_pay_button.addEventListener("click", (event) =>
      activatePayment("ShopifyPay", event)
    );
  }

  const apple_pay_button = document.querySelector(".apple_pay_button");
  if (apple_pay_button) {
    apple_pay_button.addEventListener("click", (event) =>
      activatePayment("ApplePay", event)
    );
  }
}

function updateCartItemCount(count) {
  document.querySelector(".cart_items_counter").textContent = count;
}

/*function refreshNails() {
      // Find and remove inputs with names starting with "properties["
    const inputsToRemove = document.querySelectorAll('input[name^="properties["]');
    inputsToRemove.forEach(input => input.remove());
  
  const nails = document.querySelectorAll('.color-selection__image--top, .color-selection__image3--top');
  const atcButtons = document.querySelectorAll('.main_atc_button');

  console.log(nails);

  nails.forEach(nail => {
    nail.style.backgroundColor = '#fff';
    nail.style.backgroundImage = 'url("https://www.sassysaints.com/cdn/shop/t/192/assets/blank_nail.png")';

    nail.classList.remove('coladded');
    nail.classList.remove('coladded2');
    nail.classList.remove('coladded3');

        const close = nail.querySelector('.selection-close');
        close.style.display = 'none';
        
        atcButtons.forEach(button => {
          button.style.display = 'block';
          button.nextElementSibling.style.display = 'none';
        })

        // const chosenItems = document.querySelectorAll('.coladded').length;
        // var newWidth = chosenItems * 25 / 2;
        const progress = document.querySelector('.progress-bar--selected');
        if (progress) {
          progress.style.width = 0;
          progress.style.backgroundColor = '#000';
        }

        const progress2 = document.querySelector('.progress-bar--selected2');
        if (progress2) {
          progress2.style.width = 0;
          progress2.style.backgroundColor = '#000';
        }

        const progress3 = document.querySelector('.progress-bar--selected3');
        if (progress3) {
          progress3.style.width = 0;
          progress3.style.backgroundColor = '#000';
        }

        const countPicked = document.querySelector('.color-selection__label span.count');
        if (countPicked) {
          countPicked.innerText = 0;
        }

        const countPicked2 = document.querySelector('.color-selection__label2 span.count');
        if (countPicked2) {
          countPicked2.innerText = 0;
        }

        const countPicked3 = document.querySelector('.color-selection__label3 span.count');
        if (countPicked3) {
          countPicked3.innerText = 0;
        }

        const currentCount = nail.parentElement.dataset.count;

        const text = document.querySelector(`.upper-grid__item[data-count="${currentCount}"] .color-selection-pi-text--top`);
        if (text) {
          text.style.display = 'block';
        }

        const text2 = document.querySelector(`.upper-grid__item2[data-count="${currentCount}"] .color-selection-pi-text--top`);
        if (text2) {
          text2.style.display = 'block';
        }

        const text3 = document.querySelector(`.upper-grid__item3[data-count="${currentCount}"] .color-selection-pi-text--top`);
        if (text3) {
          text3.style.display = 'block';
        }

        const titles = document.querySelectorAll(`.title${currentCount}`);
        if (titles) {
          titles.forEach(title => title.innerText = '');
        }

        const titles2 = document.querySelectorAll(`.title2${currentCount}`);
        if (titles2) {
          titles2.forEach(title => title.innerText = '');
        }

        const titles3 = document.querySelectorAll(`.title3${currentCount}`);
        if (titles3) {
          titles3.forEach(title => title.innerText = '');
        }

        const heading = document.querySelector('.color-selection__heading');
        const mainHeading = document.querySelector('.color-selection__main-heading');
        const mainHeadingSets = document.querySelector('.color-selection__main-heading_sets');

        if (mainHeading) {
          mainHeading.innerHTML = 'Choose Your Colours:';
          mainHeading.style.color = '#000';
        }

        if (mainHeadingSets) {
          mainHeadingSets.innerHTML = '2. Choose Your Colours:';
          mainHeadingSets.style.color = '#000';
        }
        
        heading.innerHTML = 'Choose Your Colours:';
        heading.style.color = '#000';
  })
}*/

function refreshNails() {
  // Find and remove inputs with names starting with "properties["
  const inputsToRemove = document.querySelectorAll(
    'input[name^="properties["]'
  );
  inputsToRemove.forEach((input) => {
    const name = input.name;
    // check for gift for variants properties
    if (name !== 'properties[_promo]') {
      input.remove();
    }    
  });

  // disabled gift for variants input and properties
  const gift_for_variant_input = document.getElementById('gift-for-variant');
  const gift_for_variant_properties = document.getElementById('gift-for-variant-properties');
  if (gift_for_variant_input) {
    gift_for_variant_input.setAttribute('disabled', 'true');
  }
  if (gift_for_variant_properties) {
    gift_for_variant_properties.setAttribute('disabled', 'true');
  }

  const nails = document.querySelectorAll(
    ".color-selection__image--top, .color-selection__image3--top"
  );
  const atcButtons = document.querySelectorAll(".main_atc_button");

  console.log(nails);

  nails.forEach((nail) => {
    nail.style.backgroundColor = "#fff";
    nail.style.backgroundImage =
      'url("https://www.sassysaints.com/cdn/shop/t/219/assets/blank_nail.png")';
    //https://www.sassysaints.com/cdn/shop/t/219/assets/blank_nail.png

    nail.classList.remove("coladded");
    nail.classList.remove("coladded2");
    nail.classList.remove("coladded3");

    const close = nail.querySelector(".selection-close");
    close.style.display = "none";

    atcButtons.forEach((button) => {
      button.style.display = "block";
      button.nextElementSibling.style.display = "none";
    });

    // const chosenItems = document.querySelectorAll('.coladded').length;
    // var newWidth = chosenItems * 25 / 2;
    const progress = document.querySelector(".progress-bar--selected");
    if (progress) {
      progress.style.width = 0;
      progress.style.backgroundColor = "#000";
    }

    const progress2 = document.querySelector(".progress-bar--selected2");
    if (progress2) {
      progress2.style.width = 0;
      progress2.style.backgroundColor = "#000";
    }

    const progress3 = document.querySelector(".progress-bar--selected3");
    if (progress3) {
      progress3.style.width = 0;
      progress3.style.backgroundColor = "#000";
    }

    const countPicked = document.querySelector(
      ".color-selection__label span.count"
    );
    if (countPicked) {
      countPicked.innerText = 0;
    }

    const countPicked2 = document.querySelector(
      ".color-selection__label2 span.count"
    );
    if (countPicked2) {
      countPicked2.innerText = 0;
    }

    const countPicked3 = document.querySelector(
      ".color-selection__label3 span.count"
    );
    if (countPicked3) {
      countPicked3.innerText = 0;
    }

    const currentCount = nail.parentElement.dataset.count;

    const text = document.querySelector(
      `.upper-grid__item[data-count="${currentCount}"] .color-selection-pi-text--top`
    );
    if (text) {
      text.style.display = "block";
    }

    const text2 = document.querySelector(
      `.upper-grid__item2[data-count="${currentCount}"] .color-selection-pi-text--top`
    );
    if (text2) {
      text2.style.display = "block";
    }

    const text3 = document.querySelector(
      `.upper-grid__item3[data-count="${currentCount}"] .color-selection-pi-text--top`
    );
    if (text3) {
      text3.style.display = "block";
    }

    const titles = document.querySelectorAll(`.title${currentCount}`);
    if (titles) {
      titles.forEach((title) => (title.innerText = `Colour ${currentCount}`));
    }

    const titles2 = document.querySelectorAll(`.title2${currentCount}`);
    if (titles2) {
      titles2.forEach((title) => (title.innerText = ""));
    }

    const titles3 = document.querySelectorAll(`.title3${currentCount}`);
    if (titles3) {
      titles3.forEach((title) => (title.innerText = ""));
    }

    const heading = document.querySelector(".color-selection__heading");
    const mainHeading = document.querySelector(
      ".color-selection__main-heading"
    );
    const mainHeadingSets = document.querySelector(
      ".color-selection__main-heading_sets"
    );

    if (mainHeading) {
      mainHeading.innerHTML = "Choose Your Colours:";
      mainHeading.style.color = "#000";
    }

    if (mainHeadingSets) {
      mainHeadingSets.innerHTML = "2. Choose Your Colours:";
      mainHeadingSets.style.color = "#000";
    }

    heading.innerHTML = "Choose Your Colours:";
    heading.style.color = "#000";
  });
}

function refreshChromeNails() {
  // Find and remove inputs with names starting with "properties["
  const inputsToRemove = document.querySelectorAll(
    'input[name^="properties["]'
  );
  inputsToRemove.forEach((input) => input.remove());

  const nails = document.querySelectorAll(
    ".color-selection__image--top, .color-selection__image3--top"
  );
  const atcButtons = document.querySelectorAll(".main_atc_button");

  console.log(nails);

  nails.forEach((nail) => {
    nail.style.backgroundColor = "#fff";
    nail.style.backgroundImage =
      'url("https://cdn.shopify.com/s/files/1/0396/9279/6066/files/blank_nail_double.png?v=1730889386")';

    nail.classList.remove("coladded");
    nail.classList.remove("coladded2");
    nail.classList.remove("coladded3");

    const close = nail.querySelector(".selection-close");
    close.style.display = "none";

    atcButtons.forEach((button) => {
      button.style.display = "block";
      button.nextElementSibling.style.display = "none";
    });

    // const chosenItems = document.querySelectorAll('.coladded').length;
    // var newWidth = chosenItems * 25 / 2;
    const progress = document.querySelector(".progress-bar--selected");
    if (progress) {
      progress.style.width = 0;
      progress.style.backgroundColor = "#000";
    }

    const progress2 = document.querySelector(".progress-bar--selected2");
    if (progress2) {
      progress2.style.width = 0;
      progress2.style.backgroundColor = "#000";
    }

    const progress3 = document.querySelector(".progress-bar--selected3");
    if (progress3) {
      progress3.style.width = 0;
      progress3.style.backgroundColor = "#000";
    }

    const countPicked = document.querySelector(
      ".color-selection__label span.count"
    );
    if (countPicked) {
      countPicked.innerText = 0;
    }

    const countPicked2 = document.querySelector(
      ".color-selection__label2 span.count"
    );
    if (countPicked2) {
      countPicked2.innerText = 0;
    }

    const countPicked3 = document.querySelector(
      ".color-selection__label3 span.count"
    );
    if (countPicked3) {
      countPicked3.innerText = 0;
    }

    const currentCount = nail.parentElement.dataset.count;

    const text = document.querySelector(
      `.upper-grid__item[data-count="${currentCount}"] .color-selection-pi-text--top`
    );
    if (text) {
      text.style.display = "block";
    }

    const text2 = document.querySelector(
      `.upper-grid__item2[data-count="${currentCount}"] .color-selection-pi-text--top`
    );
    if (text2) {
      text2.style.display = "block";
    }

    const text3 = document.querySelector(
      `.upper-grid__item3[data-count="${currentCount}"] .color-selection-pi-text--top`
    );
    if (text3) {
      text3.style.display = "block";
    }

    const titles = document.querySelectorAll(`.title${currentCount}`);
    if (titles) {
      titles.forEach((title) => (title.innerText = ""));
    }

    const titles2 = document.querySelectorAll(`.title2${currentCount}`);
    if (titles2) {
      titles2.forEach((title) => (title.innerText = ""));
    }

    const titles3 = document.querySelectorAll(`.title3${currentCount}`);
    if (titles3) {
      titles3.forEach((title) => (title.innerText = ""));
    }

    const heading = document.querySelector(".color-selection__heading");
    const mainHeading = document.querySelector(
      ".color-selection__main-heading"
    );
    const mainHeadingSets = document.querySelector(
      ".color-selection__main-heading_sets"
    );

    if (mainHeading) {
      mainHeading.innerHTML = "Choose Your Colours:";
      mainHeading.style.color = "#000";
    }

    if (mainHeadingSets) {
      mainHeadingSets.innerHTML = "2. Choose Your Colours:";
      mainHeadingSets.style.color = "#000";
    }

    heading.innerHTML = "Choose Your Colours:";
    heading.style.color = "#000";
  });
}

const addToCartForms = document.querySelectorAll('form[action="/cart/add"]');

addToCartForms.forEach((form) => {
  form.addEventListener("submit", async (event) => {
    event.preventDefault();
    const clickedElement = event.target;
    const productType = clickedElement.dataset.productType;

    const loader = form.querySelector(".loader");
    const buttonText = form.querySelector(".atc_button_text");
    const atc_button_text = document.getElementById('atc-button-text');

    const stickyLoader = document.getElementById("sticky_atc_button_loader");
    const stickyButtonText = document.getElementById("sticky_atc_button_text");

    if (atc_button_text) {
      atc_button_text.style.display = "none";
    }

    if (buttonText) {
      buttonText.style.display = "none";
    }

    if (loader) {
      loader.style.display = "block";
    }

    if (stickyButtonText) {
      stickyButtonText.style.display = "none";
    }

    if (stickyLoader) {
      stickyLoader.style.display = "block";
    }

    //buttonText?.style.display = 'none';
    //loader?.style.display = 'block';

    // Get the gift ID inputs from the form
    const giftIdInputs = form.querySelectorAll(
      'input[name^="items"]:not([disabled])'
    );

    const filteredInputs = Array.from(giftIdInputs).filter((input) => {
      const match = input.name.match(/^items\[(\d+)\]id$/);
      return match && Number(match[1]) <= 100;
    });
    
    const updates = {};

    filteredInputs.forEach((giftIdInput) => {
      const giftId = giftIdInput.value;

      if (giftId) {
        // Get the quantity for this gift from local storage
        let giftQuantity = localStorage.getItem(`gift_${giftId}_quantity`);
        giftQuantity = giftQuantity ? parseInt(giftQuantity) : 0;

        giftQuantity += 1;

        localStorage.setItem(`gift_${giftId}_quantity`, giftQuantity);

        // Add gift ID to updates object with quantity 1
        updates[giftId] = giftQuantity;
      }
    });

    // Add main product to cart along with gifts
    const currentForm = form;
    const res = await fetch("/cart/add", {
      method: "post",
      body: new FormData(currentForm),
    })
      .then(async () => {
        // Update cart with gift quantities only if main product was added successfully
        await fetch(window.Shopify.routes.root + "cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates }),
        });

        if (productType === "chrome") {
          refreshChromeNails();

          const submit_button = document.getElementById("byteex-submit-button");
          submit_button.querySelector(".uppercase").textContent =
            "choose your colours - (0/3)";
          submit_button.type = "button";

          const stickyATC = document.getElementById("sticky_atc");
          if (stickyATC) {
            stickyATC.style.display = "none";
          }
        } else if (productType === "value-box") {
          refreshNails();

          const submit_button = document.getElementById("byteex-submit-button");
          submit_button.querySelector(".uppercase").textContent =
            "choose your colours - (0/6)";
          submit_button.type = "button";

          const stickyATC = document.getElementById("sticky_atc");
          if (stickyATC) {
            stickyATC.style.display = "none";
          }
        } else if (productType === "at-home-nail-manicure-kit") {
          window.clearNailPicker();
        } else if (productType === "nail-picker-6-redesing") {
          window.clearNailPicker6Redesign();
        } else if (productType === "nail-picker-3-redesing") {
          window.clearNailPicker3Redesign();
        } else {
          refreshNails();
        }

        if (buttonText) {
          buttonText.style.display = "flex";
        }

        if (loader) {
          loader.style.display = "none";
        }

        if (stickyButtonText) {
          stickyButtonText.style.display = "inline";
        }

        if (stickyLoader) {
          stickyLoader.style.display = "none";
        }

        updateCartDrawer();
        updateNailVariables();

        if (
          !form.classList.contains("upsell_form") &&
          !form.classList.contains("addon_form")
        ) {
          onOpenDrawer();
        }
      })
      .catch((error) => console.error("Error adding to cart:", error));
  });
});

var firstNail,
  secondNail,
  thirdNail,
  fourthNail,
  fifthNail,
  sixthNail,
  seventhNail,
  eighthNail,
  ninthNail,
  tenthNail;
var color1,
  color2,
  color3,
  color4,
  color5,
  color6,
  color7,
  color8,
  color9,
  color10;
var id1, id2, id3, id4, id5, id6, id7, id8, id9, id10;
var image1,
  image2,
  image3,
  image4,
  image5,
  image6,
  image7,
  image8,
  image9,
  image10;
var index;

function changeIndex(idx) {
  index = idx;
  color1 = "";
  color2 = "";
  color3 = "";
  color4 = "";
  color5 = "";
  color6 = "";
  color7 = "";
  color8 = "";
  color9 = "";
  color10 = "";
}

async function updateNailVariables() {
  if (index > -1) {
    firstNail = document.querySelector(
      `.picker-${index} .color-selected[data-number="1"]`
    );
    secondNail = document.querySelector(
      `.picker-${index} .color-selected[data-number="2"]`
    );
    thirdNail = document.querySelector(
      `.picker-${index} .color-selected[data-number="3"]`
    );
    fourthNail = document.querySelector(
      `.picker-${index} .color-selected[data-number="4"]`
    );
    fifthNail = document.querySelector(
      `.picker-${index} .color-selected[data-number="5"]`
    );
    sixthNail = document.querySelector(
      `.picker-${index} .color-selected[data-number="6"]`
    );
    seventhNail = document.querySelector(
      `.picker-${index} .color-selected[data-number="7"]`
    );
    eighthNail = document.querySelector(
      `.picker-${index} .color-selected[data-number="8"]`
    );
    ninthNail = document.querySelector(
      `.picker-${index} .color-selected[data-number="9"]`
    );
    tenthNail = document.querySelector(
      `.picker-${index} .color-selected[data-number="10"]`
    );

    if (firstNail && !color1) {
      color1 = firstNail.getAttribute("data-color");
      id1 = firstNail.getAttribute("data-id");
      image1 = firstNail.getAttribute("data-image");
      firstNail.style.backgroundImage = `url(${image1})`;
    }

    if (secondNail && !color2) {
      color2 = secondNail.getAttribute("data-color");
      id2 = secondNail.getAttribute("data-id");
      image2 = secondNail.getAttribute("data-image");
      secondNail.style.backgroundImage = `url(${image2})`;
    }

    if (thirdNail && !color3) {
      color3 = thirdNail.getAttribute("data-color");
      id3 = thirdNail.getAttribute("data-id");
      image3 = thirdNail.getAttribute("data-image");
      thirdNail.style.backgroundImage = `url(${image3})`;
    }

    if (fourthNail && !color4) {
      color4 = fourthNail.getAttribute("data-color");
      id4 = fourthNail.getAttribute("data-id");
      image4 = fourthNail.getAttribute("data-image");
      fourthNail.style.backgroundImage = `url(${image4})`;
    }

    if (fifthNail && !color5) {
      color5 = fifthNail.getAttribute("data-color");
      id5 = fifthNail.getAttribute("data-id");
      image5 = fifthNail.getAttribute("data-image");
      fifthNail.style.backgroundImage = `url(${image5})`;
    }

    if (sixthNail && !color6) {
      color6 = sixthNail.getAttribute("data-color");
      id6 = sixthNail.getAttribute("data-id");
      image6 = sixthNail.getAttribute("data-image");
      sixthNail.style.backgroundImage = `url(${image6})`;
    }

    if (seventhNail && !color7) {
      color7 = seventhNail.getAttribute("data-color");
      id7 = seventhNail.getAttribute("data-id");
      image7 = seventhNail.getAttribute("data-image");
      seventhNail.style.backgroundImage = `url(${image7})`;
    }

    if (eighthNail && !color8) {
      color8 = eighthNail.getAttribute("data-color");
      id8 = eighthNail.getAttribute("data-id");
      image8 = eighthNail.getAttribute("data-image");
      eighthNail.style.backgroundImage = `url(${image8})`;
    }

    if (ninthNail && !color9) {
      color9 = ninthNail.getAttribute("data-color");
      id9 = ninthNail.getAttribute("data-id");
      image9 = ninthNail.getAttribute("data-image");
      ninthNail.style.backgroundImage = `url(${image9})`;
    }

    if (tenthNail && !color10) {
      color10 = tenthNail.getAttribute("data-color");
      id10 = tenthNail.getAttribute("data-id");
      image10 = tenthNail.getAttribute("data-image");
      tenthNail.style.backgroundImage = `url(${image10})`;
    }
  }
}

function addColorChangeListeners() {
  const deleteColorBtn = document.querySelectorAll(".selection-close-nail");
  deleteColorBtn.forEach((button) =>
    button.addEventListener("click", () => {
      button.parentElement.classList.remove("coloradded");
      button.parentElement.style.backgroundImage =
        'url("https://www.sassysaints.com/cdn/shop/t/192/assets/blank_nail.png")';
      button.style.display = "none";
      const number = button.parentElement.dataset.number;
      const $title = button.parentElement.nextElementSibling;
      $title.innerText = `Color${number}`;

      button.previousElementSibling.style.display = "flex";
    })
  );

  const deletechromeColorBtn = document.querySelectorAll(
    ".selection-close-chrome-nail"
  );
  deletechromeColorBtn.forEach((button) =>
    button.addEventListener("click", () => {
      button.parentElement.classList.remove("coloradded");
      button.parentElement.style.backgroundImage =
        'url("https://cdn.shopify.com/s/files/1/0396/9279/6066/files/blank_nail_double.png?v=1730889386")';
      button.style.display = "none";
      const number = button.parentElement.dataset.number;
      const $title = button.parentElement.nextElementSibling;
      $title.innerText = "";

      button.previousElementSibling.style.display = "flex";
    })
  );

  $(".color-selection__selection-grid-item.cart-clickable").click(
    async function () {
      if ($(this).data("disable") === undefined) {
        var $emptySlot = $(".color-selected:not(.coloradded)").first();

        if ($emptySlot.length) {
          var countNumber = $emptySlot.data("number");
          var $file = $(this).children(".color-selection__image").data("file");
          var $colorName = $(this)
            .children(".color-selection__image")
            .data("name");
          var $variantId = $(this)
            .children(".color-selection__image")
            .data("variant");
          var plusIcon = $emptySlot.children(".color-selection-pi-text");
          var $input = $(`#color${countNumber}`);
          var $img = $(`.color-selected[data-number=${countNumber}]`);
          plusIcon.css("display", "none");
          var $title = $emptySlot.next();
          $title.html($colorName);

          $input.val($colorName);
          $input.attr("variant-id", $variantId);
          $input.attr("variant-img", $file);

          if (parseInt(countNumber) === 1) {
            color1 = $colorName;
            id1 = $variantId;
            image1 = $file;
          }

          if (parseInt(countNumber) === 2) {
            color2 = $colorName;
            id2 = $variantId;
            image2 = $file;
          }

          if (parseInt(countNumber) === 3) {
            color3 = $colorName;
            id3 = $variantId;
            image3 = $file;
          }

          if (parseInt(countNumber) === 4) {
            color4 = $colorName;
            id4 = $variantId;
            image4 = $file;
          }

          if (parseInt(countNumber) === 5) {
            color5 = $colorName;
            id5 = $variantId;
            image5 = $file;
          }

          if (parseInt(countNumber) === 6) {
            color6 = $colorName;
            id6 = $variantId;
            image6 = $file;
          }

          if (parseInt(countNumber) === 7) {
            color7 = $colorName;
            id7 = $variantId;
            image7 = $file;
          }

          if (parseInt(countNumber) === 8) {
            color8 = $colorName;
            id8 = $variantId;
            image8 = $file;
          }

          if (parseInt(countNumber) === 9) {
            color9 = $colorName;
            id9 = $variantId;
            image9 = $file;
          }

          if (parseInt(countNumber) === 10) {
            color10 = $colorName;
            id10 = $variantId;
            image10 = $file;
          }

          $img.css("backgroundImage", `url(${$file})`);
          $img.addClass("coloradded");

          $(".click.active").removeClass("active");
          $(".click:not(.coloradded)").first().addClass("active");

          var close = $img.find(".selection-close-nail");
          close.css("display", "flex");

          close.on("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            $img.removeClass("coloradded");
            $img.css(
              "backgroundImage",
              `url({{ 'blank_nail.png' | asset_url }})`
            );
            $input.val("");
            $input.removeAttr("variant-id");
            $input.removeAttr("variant-img");
            close.css("display", "none");
            plusIcon.css("display", "flex");
            // $title.text(`Color${count}`);
          });

          var close_chrome = $img.find(".selection-close-chrome-nail");
          close_chrome.css("display", "flex");

          close_chrome.on("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            $img.removeClass("coloradded");
            $img.css(
              "backgroundImage",
              `url({{ 'blank_nail.png' | asset_url }})`
            );
            $input.val("");
            $input.removeAttr("variant-id");
            $input.removeAttr("variant-img");
            close.css("display", "none");
            plusIcon.css("display", "flex");
            // $title.text(`Color${count}`);
          });
        }
      }
    }
  );

  // Get all the color filter elements
  const cartColorSelection = document.querySelector(".cart-color-selection");
  if (cartColorSelection) {
    var colorFilters1 = cartColorSelection.querySelectorAll(
      ".color-choose-filter1"
    );

    // Create an array to store the selected colors
    var selectedColors1 = [];

    // Attach click event listeners to each color filter element
    colorFilters1.forEach(function (filter) {
      filter.addEventListener("click", function (e) {
        e.preventDefault();

        // Get the selected color from the clicked filter
        console.log("filter");
        var selectedColor = this.getAttribute("data-color");

        // Toggle the selection of the clicked color
        if (selectedColor === "All") {
          // If "All" is selected, clear the selectedColors1 array to show all elements
          selectedColors1 = [];
        } else {
          // Toggle the selection of the color
          var index = selectedColors1.indexOf(selectedColor);
          // if (index !== -1) {
          selectedColors1.splice(index, 1);
          //     console.log('if', selectedColors1)
          // } else {
          selectedColors1.push(selectedColor);
          console.log("else", selectedColors1);
          // }
        }

        // Get all the clickable elements
        const clickableElements = document.querySelectorAll(".cart-clickable");

        // Loop through the clickable elements and check if they match any selected color
        clickableElements.forEach(function (element) {
          var elementColors = element.getAttribute("data-filters").split(",");

          if (
            selectedColors1.length === 0 ||
            elementColors.some((color) => selectedColors1.includes(color))
          ) {
            element.style.display = "block";
          } else {
            element.style.display = "none";
          }
        });

        // Remove "active" class from all color filter elements
        colorFilters1.forEach(function (colorFilter) {
          colorFilter.classList.remove("active");
          colorFilter.closest("li").classList.remove("active");
        });

        // Add "active" class to the clicked color filter element
        this.classList.add("active");
        this.closest("li").classList.add("active");
        e.stopPropagation();
      });
    });

    // Get all the color filter elements
    var colorFilters2 = cartColorSelection.querySelectorAll(
      ".color-choose-filter2"
    );

    // Create an array to store the selected colors
    var selectedColors2 = [];

    // Attach click event listeners to each color filter element
    colorFilters2.forEach(function (filter) {
      filter.addEventListener("click", function (e) {
        e.preventDefault();

        // Get the selected color from the clicked filter
        console.log("filter");
        var selectedColor = this.getAttribute("data-color");

        // Toggle the selection of the clicked color
        if (selectedColor === "All") {
          // If "All" is selected, clear the selectedColors2 array to show all elements
          selectedColors2 = [];
        } else {
          // Toggle the selection of the color
          var index = selectedColors2.indexOf(selectedColor);
          // if (index !== -1) {
          selectedColors2.splice(index, 1);
          //     console.log('if', selectedColors2)
          // } else {
          selectedColors2.push(selectedColor);
          console.log("else", selectedColors2);
          // }
        }

        // Get all the clickable elements
        var clickableElements = document.querySelectorAll(".cart-clickable");

        // Loop through the clickable elements and check if they match any selected color
        clickableElements.forEach(function (element) {
          var elementColors = element.getAttribute("data-filters").split(",");

          if (
            selectedColors2.length === 0 ||
            elementColors.some((color) => selectedColors2.includes(color))
          ) {
            element.style.display = "block";
          } else {
            element.style.display = "none";
          }
        });

        // Remove "active" class from all color filter elements
        colorFilters2.forEach(function (colorFilter) {
          colorFilter.classList.remove("active");
          colorFilter.closest("li").classList.remove("active");
        });

        // Add "active" class to the clicked color filter element
        this.classList.add("active");
        this.closest("li").classList.add("active");
        e.stopPropagation();
      });
    });

    // Get all the color filter elements
    var colorFilters3 = cartColorSelection.querySelectorAll(
      ".color-choose-filter3"
    );

    // Create an array to store the selected colors
    var selectedColors3 = [];

    // Attach click event listeners to each color filter element
    colorFilters3.forEach(function (filter) {
      filter.addEventListener("click", function (e) {
        e.preventDefault();

        // Get the selected color from the clicked filter
        console.log("filter");
        var selectedColor = this.getAttribute("data-color");

        // Toggle the selection of the clicked color
        if (selectedColor === "All") {
          // If "All" is selected, clear the selectedColors3 array to show all elements
          selectedColors3 = [];
        } else {
          // Toggle the selection of the color
          var index = selectedColors3.indexOf(selectedColor);
          // if (index !== -1) {
          selectedColors3.splice(index, 1);
          //     console.log('if', selectedColors3)
          // } else {
          selectedColors3.push(selectedColor);
          console.log("else", selectedColors3);
          // }
        }

        // Get all the clickable elements
        var clickableElements = document.querySelectorAll(".cart-clickable");

        // Loop through the clickable elements and check if they match any selected color
        clickableElements.forEach(function (element) {
          var elementColors = element.getAttribute("data-filters").split(",");

          if (
            selectedColors3.length === 0 ||
            elementColors.some((color) => selectedColors3.includes(color))
          ) {
            element.style.display = "block";
          } else {
            element.style.display = "none";
          }
        });

        // Remove "active" class from all color filter elements
        colorFilters3.forEach(function (colorFilter) {
          colorFilter.classList.remove("active");
          colorFilter.closest("li").classList.remove("active");
        });

        // Add "active" class to the clicked color filter element
        this.classList.add("active");
        this.closest("li").classList.add("active");
        e.stopPropagation();
      });
    });
  }
}

async function updateChromeColorsAndCart(key) {
  await updateNailVariables();
  let changes = {
    id: key,
    properties: {
      "Chrome 1": color1,
      "Chrome 2": color2,
      "Chrome 3": color3,
      "_id1.": id1,
      "_id2.": id2,
      "_id3.": id3,
      "_1.": image1,
      "_2.": image2,
      "_3.": image3,
    },
  };

  try {
    await fetch(window.Shopify.routes.root + "cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(changes),
    });
    await updateCartDrawer();
  } catch (error) {
    console.error("Error:", error);
  }
}

async function updateColorsAndCart(key) {
  await updateNailVariables();
  let changes = {
    id: key,
    properties: {
      "Colour 1": color1,
      "Colour 2": color2,
      "Colour 3": color3,
      "_id1.": id1,
      "_id2.": id2,
      "_id3.": id3,
      "_1.": image1,
      "_2.": image2,
      "_3.": image3,
    },
  };

  if (color4) {
    changes = {
      id: key,
      properties: {
        "Colour 1": color1,
        "Colour 2": color2,
        "Colour 3": color3,
        "Colour 4": color4,
        "_id1.": id1,
        "_id2.": id2,
        "_id3.": id3,
        "_id4.": id4,
        "_1.": image1,
        "_2.": image2,
        "_3.": image3,
        "_4.": image4,
      },
    };
  }

  if (color5) {
    changes = {
      id: key,
      properties: {
        "Colour 1": color1,
        "Colour 2": color2,
        "Colour 3": color3,
        "Colour 4": color4,
        "Colour 5": color5,
        "_id1.": id1,
        "_id2.": id2,
        "_id3.": id3,
        "_id4.": id4,
        "_id5.": id5,
        "_1.": image1,
        "_2.": image2,
        "_3.": image3,
        "_4.": image4,
        "_5.": image5,
      },
    };
  }

  if (color6) {
    changes = {
      id: key,
      properties: {
        "Colour 1": color1,
        "Colour 2": color2,
        "Colour 3": color3,
        "Colour 4": color4,
        "Colour 5": color5,
        "Colour 6": color6,
        "_id1.": id1,
        "_id2.": id2,
        "_id3.": id3,
        "_id4.": id4,
        "_id5.": id5,
        "_id6.": id6,
        "_1.": image1,
        "_2.": image2,
        "_3.": image3,
        "_4.": image4,
        "_5.": image5,
        "_6.": image6,
      },
    };
  }

  if (color7) {
    changes = {
      id: key,
      properties: {
        "Colour 1": color1,
        "Colour 2": color2,
        "Colour 3": color3,
        "Colour 4": color4,
        "Colour 5": color5,
        "Colour 6": color6,
        "Colour 7": color7,
        "_id1.": id1,
        "_id2.": id2,
        "_id3.": id3,
        "_id4.": id4,
        "_id5.": id5,
        "_id6.": id6,
        "_id7.": id7,
        "_1.": image1,
        "_2.": image2,
        "_3.": image3,
        "_4.": image4,
        "_5.": image5,
        "_6.": image6,
        "_7.": image7,
      },
    };
  }

  if (color8) {
    changes = {
      id: key,
      properties: {
        "Colour 1": color1,
        "Colour 2": color2,
        "Colour 3": color3,
        "Colour 4": color4,
        "Colour 5": color5,
        "Colour 6": color6,
        "Colour 7": color7,
        "Colour 8": color8,
        "_id1.": id1,
        "_id2.": id2,
        "_id3.": id3,
        "_id4.": id4,
        "_id5.": id5,
        "_id6.": id6,
        "_id7.": id7,
        "_id8.": id8,
        "_1.": image1,
        "_2.": image2,
        "_3.": image3,
        "_4.": image4,
        "_5.": image5,
        "_6.": image6,
        "_7.": image7,
        "_8.": image8,
      },
    };
  }

  if (color9) {
    changes = {
      id: key,
      properties: {
        "Colour 1": color1,
        "Colour 2": color2,
        "Colour 3": color3,
        "Colour 4": color4,
        "Colour 5": color5,
        "Colour 6": color6,
        "Colour 7": color7,
        "Colour 8": color8,
        "Colour 9": color9,
        "_id1.": id1,
        "_id2.": id2,
        "_id3.": id3,
        "_id4.": id4,
        "_id5.": id5,
        "_id6.": id6,
        "_id7.": id7,
        "_id8.": id8,
        "_id9.": id9,
        "_1.": image1,
        "_2.": image2,
        "_3.": image3,
        "_4.": image4,
        "_5.": image5,
        "_6.": image6,
        "_7.": image7,
        "_8.": image8,
        "_9.": image9,
      },
    };
  }

  if (color10) {
    changes = {
      id: key,
      properties: {
        "Colour 1": color1,
        "Colour 2": color2,
        "Colour 3": color3,
        "Colour 4": color4,
        "Colour 5": color5,
        "Colour 6": color6,
        "Colour 7": color7,
        "Colour 8": color8,
        "Colour 9": color9,
        "Colour 10": color10,
        "_id1.": id1,
        "_id2.": id2,
        "_id3.": id3,
        "_id4.": id4,
        "_id5.": id5,
        "_id6.": id6,
        "_id7.": id7,
        "_id8.": id8,
        "_id9.": id9,
        "_id10.": id10,
        "_1.": image1,
        "_2.": image2,
        "_3.": image3,
        "_4.": image4,
        "_5.": image5,
        "_6.": image6,
        "_7.": image7,
        "_8.": image8,
        "_9.": image9,
        "_10.": image10,
      },
    };
  }

  try {
    await fetch(window.Shopify.routes.root + "cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(changes),
    });
    await updateCartDrawer();
  } catch (error) {
    console.error("Error:", error);
  }
}

addCartDrawerListeners();
addColorChangeListeners();
checkAndAddGifts();
